// // RichEditor.jsx
// import React, { useState, useEffect } from 'react';
// import { Editor } from 'react-draft-wysiwyg';
// import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// const RichEditor = ({ value, onChange }) => {
//   const [editorState, setEditorState] = useState(
//     value ? EditorState.createWithContent(convertFromRaw(JSON.parse(value))) : EditorState.createEmpty()
//   );

//   useEffect(() => {
//     const rawContent = convertToRaw(editorState.getCurrentContent());
//     onChange(JSON.stringify(rawContent));
//   }, [editorState]);

//   return (
//     <div className="rich-editor">
//       <Editor
//         editorState={editorState}
//         onEditorStateChange={setEditorState}
//         toolbar={{
//           options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link', 'emoji', 'history'],
//         }}
//       />
//     </div>
//   );
// };

// export default RichEditor;

// RichEditor.jsx
import React, { useEffect, useState } from 'react';
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

const RichEditor = ({ value, onChange }) => {
  const [content, setContent] = useState(value || '');

  useEffect(() => {
    if (typeof onChange === 'function') {
      onChange(content);
    }
  }, [content]);

  return (
    <div className="rich-editor">
      <CKEditor
        editor={ClassicEditor}
        data={content}
        onChange={(event, editor) => {
          const data = editor.getData();
          setContent(data);
        }}
      />
    </div>
  );
};

export default RichEditor;